import { useState } from 'react';

export function useAutocompleteInput(setTableSearch: (value: string) => void = () => {}) {
  const [display, setDisplay] = useState('');
  const [query, setQuery] = useState('');

  const onSearch = (value: string, optionIds: string[] = []) => {
    if (optionIds.includes(value)) return;
    setDisplay(value);
    setQuery(value);
    setTableSearch(value);
  };

  const onSelect = (displayValue: string, callback: () => void) => {
    callback();
    setDisplay(displayValue);
  };

  const clear = () => {
    setDisplay('');
    setQuery('');
    setTableSearch('');
  };

  return { display, query, onSearch, onSelect, clear, setDisplay, setQuery };
}

/** True while debounce is pending or the autocomplete API request is in flight. */
export function useAutocompleteLoading(
  query: string,
  debouncedQuery: string,
  apiLoading: boolean,
): boolean {
  if (!query.trim()) return false;
  return query !== debouncedQuery || apiLoading;
}
